import { combineReducers } from 'redux'
// import ConstructionsReducer from './ConstructionsReducer'
// import PropertiesReducer from './PropertiesReducer'
import Users from './Users'
import NewLogo from './NewLogo'
import Purchases from './Purchases'
// import EvaluationsReducer from './EvaluationsReducer'
// import DashboardReducer from './Dashboard'
// import undoable from 'redux-undo'
// import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
  // undoGroup: undoable(combineReducers({
  //   constructions: ConstructionsReducer,
  //   properties: PropertiesReducer,
  //   evaluations: EvaluationsReducer
  // })),
  // form: formReducer,
  users: Users,
  newLogo: NewLogo,
  purchases: Purchases
  // dashboard: DashboardReducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js